import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Formik, Form, Field, ErrorMessage } from 'formik';

import EgrList from './EgrList';
import Pagination from './Pagination';

import { fetchExternalGroupRelationsAction, fetchExternalGroupRelationsFailure } from '../actions';
import EgrCreateForm from './EgrCreateForm';

import '../../../../app/assets/stylesheets/egr.scss';
import GroupSearch from './GroupSearch';

class EgrIndex extends Component {

  constructor(props) {
    super(props);
  }

  handleSearch(values, actions) {
    const { external_group_ids, legacy_group_ids } = values;
    if (_.isEmpty(external_group_ids.trim()) && _.isEmpty(legacy_group_ids.trim())) {
      this.props.fetchExternalGroupRelationsFailure(['Atleast one field should be filled up']);
      return;
    }
    const payload = {
      external_group_ids,
      legacy_group_ids,
      before: null,
      after:  null
    };
    this.props.fetchExternalGroupRelationsAction(payload);
  }

  render() {
    return (
      <div className="egr_screen">
        <h1>EGR Management</h1>
        {this.props.notice && <div className="notice">{this.props.notice}</div>}
        <GroupSearch />
        <div className="search_container">
          <h2>Search External Group Relations</h2>
          <Formik
            initialValues={{ external_group_ids: '', legacy_group_ids: '' }}
            onSubmit={(values, actions) => this.handleSearch(values, actions)}
          >
            {() => (
              <React.Fragment>
                {this.props.errors && !_.isEmpty(this.props.errors) &&
                  <div className="error">
                    {this.props.errors.map((error, index) => (
                      <p key={index}>{error}</p>
                    ))}
                  </div>}
                <Form>
                  <div className="egr_search_fields">
                    <div className="label_container">
                      <label htmlFor="external_group_ids">Vendor Group Id</label>
                      <label htmlFor="legacy_group_ids">Legacy Group Id</label>
                    </div>
                    <div className="field_container">
                      <Field name="external_group_ids" type="text" />
                      <Field name="legacy_group_ids" type="text" />
                      <ErrorMessage name="external_group_ids" />
                      <ErrorMessage name="legacy_group_ids" />
                    </div>
                  </div>
                  <div className="button_container">
                    <button
                      className="button"
                      type="submit"
                      disabled={this.props.isSearching}
                    >
                      {this.props.isSearching ? 'Searching ...' : 'Search'}
                    </button>
                  </div>
                </Form>
              </React.Fragment>
            )}
          </Formik>
        </div>
        <EgrCreateForm
          stateCodes={this.props.stateCodes}
          permittedTypeCodes={this.props.permittedTypeCodes}
          hasBillingAccess={this.props.hasBillingAccess}
        />
        <EgrList
          externalGroupRelations={this.props.externalGroupRelations}
          stateCodes={this.props.stateCodes}
          hasBillingAccess={this.props.hasBillingAccess}
          permittedTypeCodes={this.props.permittedTypeCodes}
        />
        {this.props.externalGroupRelations && !_.isEmpty(this.props.externalGroupRelations) &&
          <Pagination />}
      </div>
    );
  }
}

EgrIndex.propTypes = {
  fetchExternalGroupRelationsAction:  PropTypes.func,
  fetchExternalGroupRelationsFailure: PropTypes.func,
  errors:                             PropTypes.array,
  notice:                             PropTypes.string,
  externalGroupRelations:             PropTypes.array,
  stateCodes:                         PropTypes.array,
  permittedTypeCodes:                 PropTypes.array,
  isSearching:                        PropTypes.bool,
  hasBillingAccess:                   PropTypes.bool
};

const mapStateToProps = state => ({
  externalGroupRelations: state.egrReducer.externalGroupRelations,
  errors:                 state.egrReducer.errors,
  notice:                 state.egrReducer.notice,
  startCursor:            state.egrReducer.startCursor,
  endCursor:              state.egrReducer.endCursor,
  hasPrevPage:            state.egrReducer.hasPrevPage,
  hasNextPage:            state.egrReducer.hasNextPage,
  isSearching:            state.egrReducer.isSearching
});

const mapDispatchToProps = {
  fetchExternalGroupRelationsAction,
  fetchExternalGroupRelationsFailure
};

export default connect(mapStateToProps, mapDispatchToProps)(EgrIndex);
